var map = {
	"./ailments-bg.jpg": "80aa",
	"./auth.jpg": "205d",
	"./black.png": "211b",
	"./help-icon.svg": "ae7c",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./steps/step1.svg": "80a6",
	"./steps/step2.svg": "1e12",
	"./steps/step3.svg": "8608"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7542";